// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"288dfc20","133":"3f55ce08","182":"d89936cf"}[chunkId] + ".chunk.js";
};